import { RootState } from '../../../app/store';
import { createSelector, createSlice, PayloadAction } from "@reduxjs/toolkit"
import ExpenseModel from '../models/ExpenseModel';
import ItemsAndTypesModel from '../../Investment/models/ItemsAndTypesModel';

interface ExpenseInputState {
    input: ExpenseModel,
    selectedExpenseId: string,
    ExpenseInputExpand: boolean,
    triggerFocusCompanyNameInput: number,
    triggerSave: number,
    triggerRefreshInput: number,
    expenseItems: string[],
    showExpenseDetail: boolean
}

const initialState: ExpenseInputState = {
    input: {
        id: "",
        items: "",
        type: "",
        month: "",
        amount: 0,
    } as unknown as ExpenseModel,
    selectedExpenseId: "",
    ExpenseInputExpand: true,
    triggerFocusCompanyNameInput: 0,
    triggerSave: 0,
    triggerRefreshInput: 0,
    expenseItems: [],
    showExpenseDetail: false
}

export const ExpenseInputSlice = createSlice({
    name: "ExpenseInput",
    initialState,
    reducers: {
        setExpenseInputId: (state, action: PayloadAction<string>) => {
            state.input.id = action.payload;
        },
        setExpenseInput: (state, action: PayloadAction<ExpenseModel>) => {
            state.input = action.payload;
        },
        setItems: (state, action: PayloadAction<string>) => {
            state.input.items = action.payload;
        },
        setType: (state, action: PayloadAction<string>) => {
            state.input.type = action.payload;
        },
        setMonth: (state, action: PayloadAction<string>) => {
            state.input.month = action.payload;
        },
        setAmount: (state, action: PayloadAction<number>) => {
            state.input.amount = action.payload;
        },
        setSelectedExpenseId: (state, action: PayloadAction<string>) => {
            state.selectedExpenseId = action.payload;
        },
        setExpenseInputExpand: (state, action: PayloadAction<boolean>) => {
            state.ExpenseInputExpand = action.payload;
        },
        setTriggerFocusCompanyNameInput: (state, action: PayloadAction<number>) => {
            state.triggerFocusCompanyNameInput = action.payload;
        },
        resetExpenseInput: (state) => {
            state.input = initialState.input;
        },
        setTriggerSave: (state, action: PayloadAction<number>) => {
            state.triggerSave = action.payload;
        },
        setTriggerRefreshInput: (state, action: PayloadAction<number>) => {
            state.triggerRefreshInput = action.payload;
        },
        setExpenseItems: (state, action: PayloadAction<string[]>) => {
            state.expenseItems = action.payload;
        },
        setShowExpenseDetail: (state, action: PayloadAction<boolean>) => {
            state.showExpenseDetail = action.payload;
        },
    }
});

export const ExpenseInputSelector = createSelector(
    (state: RootState) => state.ExpenseInput,
    (data) => data
);

export const {
    setExpenseInputId,
    setExpenseInput,
    setItems,
    setType,
    setMonth,
    setAmount,
    setSelectedExpenseId,
    setExpenseInputExpand,
    setTriggerFocusCompanyNameInput,
    resetExpenseInput,
    setTriggerSave,
    setTriggerRefreshInput,
    setExpenseItems,
    setShowExpenseDetail
} = ExpenseInputSlice.actions;

export default ExpenseInputSlice.reducer;